// removed by extract-text-webpack-plugin
module.exports = {"_miedzyslowami_":"Logo___miedzyslowami____1vuL6","logo":"Logo__logo___2fbJZ","text":"Logo__text___uRoCI","text__1":"Logo__text__1___1tiI9","text__2":"Logo__text__2___L0UBy","text__3":"Logo__text__3___1bkRk","text__4":"Logo__text__4___1aaTf","text__5":"Logo__text__5___2wy71","text__6":"Logo__text__6___2Z3ah","text__7":"Logo__text__7___lf6lt","text__8":"Logo__text__8___1vSkM","text__9":"Logo__text__9___3OhnQ","text__10":"Logo__text__10___1qMyk","text__11":"Logo__text__11___C3PEf","text__12":"Logo__text__12___1ZrIz","text__13":"Logo__text__13___WcQDl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.scss
// module id = 78
// module chunks = 0